<app-basic-page [pageTitle]="'Tags'">
  <!-- <button nz-button nzType="primary" nzSize="default" (click)="onNewBtnClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
          Add Tag
        </button> -->
  @for (rootTag of rootTagList(); track $index) {
    <div class="basic-card tag-card vertical-large">
      <div class="horizontal seperate">
        <h3 class="title">{{ rootTag.title }}</h3>
        <div class="horizontal">
          <button
            class="button"
            nz-button
            nzType="primary"
            [nzSize]="'small'"
            [matTooltip]="'Add New Tag'"
            (click)="onNewBtnClick(rootTag)"
          >
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
          </button>
          <button
            class="button"
            nz-button
            nzType="default"
            [nzSize]="'small'"
            [matTooltip]="'Edit Tag'"
            (click)="onEditTagClick(rootTag)"
          >
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
          </button>
          <button
            class="button"
            nz-button
            nzType="primary"
            [nzSize]="'small'"
            [nzDanger]="true"
            [matTooltip]="'Delete Tag'"
          >
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
          </button>
        </div>
      </div>

      @for (tag of getTagList(rootTag.id); track $index) {
        <div class="horizontal seperate tag-row">
          <nz-tag [nzColor]="tag.unsafeSubData?.color ?? 'volcano'">{{ tag.title }}</nz-tag>
          <div class="horizontal">
            <button class="tag-button" nz-button nzType="default" [nzSize]="'small'" [matTooltip]="'Edit'">
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
            </button>
            <button
              class="tag-button"
              nz-button
              nzType="default"
              [nzSize]="'small'"
              [nzDanger]="true"
              [matTooltip]="'Delete'"
            >
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
            </button>
          </div>
        </div>
      }
    </div>
  }
</app-basic-page>

<app-new-edit-tag
  [(isNewEditVisible)]="isNewEditVisible"
  [parentTag]="selectedParentTag"
  [selectedItem]="selectedTag"
  (isNewEditVisibleChange)="newEditTagVisibleChange($event)"
></app-new-edit-tag>
